import { useQuery } from '@tanstack/react-query';
import { workspaceSettingsApi } from '@/api';
import { useAuth } from '@/contexts/AuthContext';
import { canManageWorkspace } from '@/lib/permissions';
import { workspaceSettingsKeys } from '@/lib/queryKeys';

export function useWorkspaceSettings() {
  const { user } = useAuth();
  return useQuery({
    queryKey: workspaceSettingsKeys.all,
    queryFn: workspaceSettingsApi.get,
    enabled: canManageWorkspace(user?.role),
  });
}
